module.exports = __webpack_public_path__ + "img/bb_g3_mouth-06.291bf018.svg";